import { Stack } from "@tine/designsystem-ui-react";
import type { ContentfulAccordion } from "../../../common/types/cmsTypes";

import CmsAccordion from "./CmsAccordion";

type AccordionListProps = {
   accordionList: ContentfulAccordion[];
   title?: string;
};

const AccordionList = ({ accordionList, title }: AccordionListProps) => {
   const listClassName = "tw-divide-x-0 tw-divide-y tw-divide-ink-border-subtle tw-divide-solid tw-list-none tw-ps-0 tw-w-full";

   return (
      <>
         {title && (
            <h2 className="tw-mb-4 tw-h-5 tw-text-start tw-w-full tw-text-lg/7  tw-mx-0 md:tw-w-3/4 md:tw-mx-auto tw-max-w-[848px]">
               {title}
            </h2>
         )}
         {accordionList.map((accordionContent) => (
            <div
               key={`accordion-${accordionContent.sys.id}`}
               className="tw-w-full tw-mx-0 md:tw-w-3/4 md:tw-mx-auto tw-max-w-[848px]"
            >
               <Stack gap={6} className="tw-w-full">
                  <ul className={listClassName}>
                     <li>
                        <CmsAccordion accordionContent={accordionContent} />
                     </li>
                  </ul>
               </Stack>
            </div>
         ))}
      </>
   );
};

export default AccordionList;
